var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiretCoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 85,
    viewBox: "0 0 2 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V85",
    stroke: "#666666",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "7 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiretCoupons);
export default __webpack_public_path__ + "static/media/tiret_coupons.b011ecae19949e8c6fa3026d4111818e.svg";
export { ForwardRef as ReactComponent };